const isNull = (str) => {
  if(str != null && str != '' && str != undefined){
    return false
  }
  return true
}

const stringUtil={
  'isNull':isNull
}

export default stringUtil